import {
  PillDropdown,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const PillContainer = styled.div`
  flex: 1;
`;

export const StyledPillDropdown = styled(PillDropdown)`
  ${typographyV2.bodySm}
  align-items: center;
  text-transform: capitalize;
`;

export const StyledHeader = styled.span`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const AssetHeader = styled.div`
  display: flex;
  width: calc(100% - 40px);
  flex-direction: column;
  align-items: start;
  justify-content: center;
  #company-label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #company-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    ${typographyV2.bodySm}
    color : var(--text-soft)
  }
`;

export const StyledLogoImg = styled.img<{
  $size: number;
}>`
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  background-color: var(--surface-inverse);
`;

export const LogoFallback = styled.div<{
  $size: number;
}>`
  display: flex;
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  background-color: var(--surface-default);
  color: var(--text-default);
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  ${typographyV2.bodySm};
  font-weight: 500;
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '125px',
        height: '48px',
        borderRadius: '8px',
      },
    },
  ],
})``;
